
<template>

  <div id="app" class="body" :class="{ 'page-menu-closed': menuCollapsed }">
    <router-view
            :appMenuCollapsed="menuCollapsed"
            @menu-toggled="onToggled"
    />

  </div>

</template>

<script>
  import jivoService from './jivoService';
  export default {
      name: 'app',
      data() {
          return {
              menuCollapsed: false
          }
      },
      methods:{
          onToggled(){
              this.menuCollapsed = !this.menuCollapsed;
          }
      },
      mounted() {
          jivoService.init();
      },
      watch: {
          '$route'(to) {
            jivoService.checkUrl();
          }
      }
  }
</script>


<style>

</style>



// WEBPACK FOOTER //
// Content/src/App.vue